import { render, staticRenderFns } from "./OptionSelector.vue?vue&type=template&id=f49da8a6&scoped=true"
import script from "./OptionSelector.vue?vue&type=script&lang=js"
export * from "./OptionSelector.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f49da8a6",
  null
  
)

export default component.exports